import { 
  Home, 
  Package, 
  Grid, 
  Building2, 
  FileText, 
  Briefcase, 
  Phone, 
  BookText, 
  Users,
  Shield,
  Brain,
  Eye,
  MessageSquare,
  Volume2,
  TrendingUp,
  Settings,
  CheckCircle,
  Database,
  Smartphone,
  Bot,
  FileSearch,
  Search,
  Box,
  BarChart3,
  Cloud,
  Layers,
  Target,
  Factory,
  HelpCircle,
  Sparkles
} from "lucide-react"

export const MENU = [
  { label: "Home", href: "/", icon: Home },
  { label: "AI Consulting", href: "/ai-consulting", icon: Sparkles },
  {
    label: "Services",
    icon: Package,
    children: [
      {
        group: "AI & Data Solutions",
        items: [
          { label: "About AI & Data Solutions", href: "/about-ai", icon: HelpCircle },
          { label: "Multimodal AI", href: "/multimodal-ai", icon: Brain },
          { label: "Computer Vision", href: "/computer-vision", icon: Eye },
          { label: "Natural Language Processing", href: "/natural-language-processing", icon: MessageSquare },
          { label: "Audio AI", href: "/audio-ai", icon: Volume2 },
          { label: "Predictive Analytics", href: "/predictive-analytics", icon: TrendingUp },
          { label: "AI Infrastructure (MLOps)", href: "/mlops", icon: Settings },
          { label: "Responsible AI", href: "/responsible-ai", icon: CheckCircle },
        ],
      },
      {
        group: "Smart Industry Applications",
        items: [
          { label: "About Smart Industry Application", href: "/about-smart", icon: HelpCircle },
          { label: "ERP Systems", href: "/erp-systems", icon: Database },
          { label: "IMS", href: "/ims", icon: Layers },
          { label: "EMS", href: "/ems", icon: Settings },
          { label: "Web & Mobile Apps", href: "/web-mobile-apps", icon: Smartphone },
          { label: "Chatbots & Assistants", href: "/chatbots-assistants", icon: Bot },
          { label: "Document Automation", href: "/document-automation", icon: FileSearch },
          { label: "Search & Retrieval", href: "/search-retrieval", icon: Search },
          { label: "Digital Twins & 3D", href: "/digital-twins", icon: Box },
        ],
      },
      {
        group: "Data & Cloud Services",
        items: [
          { label: "About Data & Cloud Services", href: "/about-data", icon: HelpCircle },
          { label: "Data Labeling", href: "/data-labeling", icon: Target },
          { label: "Pipelines & Dashboards", href: "/pipelines-dashboards", icon: BarChart3 },
          { label: "Cloud & Edge AI", href: "/cloud-edge-ai", icon: Cloud },
          { label: "Dataset Development", href: "/dataset-development", icon: Database },
          { label: "Enterprise AI Consulting", href: "/enterprise-ai-consulting", icon: Briefcase },
        ],
      },
    ],
  },
  {
    label: "Sectors",
    icon: Grid,
    children: [
      { label: "Government & Public Services", href: "/government", icon: Building2 },
      { label: "Healthcare", href: "/healthcare", icon: Users },
      { label: "Finance & Banking", href: "/finance", icon: FileText },
      { label: "Smart Cities & Infrastructure", href: "/smart-cities", icon: Grid },
      { label: "Tourism & Hospitality", href: "/tourism", icon: BookText },
      { label: "Education", href: "/education", icon: BookText },
      { label: "Retail & Commerce", href: "/retail", icon: BookText },
      { label: "Defense & Security", href: "/security", icon: Shield },
      { label: "Private Sector", href: "/private-sector", icon: Briefcase },
      { label: "Hotels & Hospitality", href: "/hotels", icon: Building2 },
    ],
  },
  {
    label: "Company",
    icon: Building2,
    children: [
      { label: "About", href: "/about" },
      { label: "Contact", href: "/contact" },
    ],
  },
]

export type MenuItem = typeof MENU[0]
export type MenuGroup = MenuItem & { children: Array<{ group?: string; items?: Array<{ label: string; href: string; icon?: any }> } | { label: string; href: string; icon?: any }> }